import React from 'react'
import ContactUs from '../components/ContactUs/ContactUs'

const Contacts = () => {
  return (
    <div>
        <ContactUs />
    </div>
  )
}

export default Contacts